module.exports = __webpack_public_path__ + "img/raporty_inactive.431b6c88.svg";